var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Status_ReembolsoActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Status_ReembolsoModule = class Status_ReembolsoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Status_ReembolsoActions.POST_STATUS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Status_Reembolso/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Status_ReembolsoActions.PUT_STATUS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.put("Status_Reembolso/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Status_ReembolsoActions.DELETE_STATUS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Status_Reembolso/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Status_ReembolsoActions.DELETE_RANGE_STATUS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Status_Reembolso/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Status_ReembolsoActions.FILTER_STATUS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Status_Reembolso/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Status_ReembolsoActions.GET_STATUS_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Status_Reembolso/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Status_ReembolsoActions.GETWITHDISABLED_STATUS_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Status_Reembolso/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Status_ReembolsoActions.GET_BY_ID_STATUS_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.get("Status_Reembolso/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Status_ReembolsoModule.prototype, _h, null);
Status_ReembolsoModule = __decorate([
    Module
], Status_ReembolsoModule);
export default Status_ReembolsoModule;
//# sourceMappingURL=Status_ReembolsoModule.js.map